<template>
  <multi-selection-tool-button
    icon="save"
    :disabled="disabled"
    :tooltip="$t('SaveChanges')"
    @click="$emit('click')"
  />
</template>

<script>
import MultiSelectionToolButton from "@/components/Home/Forms/_Atoms/TableToolbarButton";

export default {
  name: "HomeFormTableSaveTool",

  components: { MultiSelectionToolButton },

  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_Atoms/TableToolbarButtons/Save.vue